import React from "react";
import { connect } from "react-redux";

import { TabNavigation, Logo } from "components";
import { MOVE_TAB, UPDATE_INPUT } from "actions";

const Tab1DrawnDown = props => {
  const selectedNo = () => {
    props.updateInput({
      name: "requiresInvoiceFinance",
      value: false
    });
    props.moveToNextTab();
  };
  const selectedYes = () => {
    props.updateInput({
      name: "requiresInvoiceFinance",
      value: true
    });
    props.moveToNextTab();
  };

  const { domainBaseColour, domain } = props;

  return (
    <div className="form_steps test_tab1_drawn_down">
      <div className="form_steps--inner flex">
        <div className="full_column">
          <Logo />
          <TabNavigation />
          <div className="form_content">
            <h2 className="link_checkbox_container--title">
              {domain.Strings.tab1DrawnDownTitle}
            </h2>
            <div className="checkbox_container--content">
              <p>{domain.Strings.tab1DrawnDownSubTitle}</p>
            </div>
            <div className="link_checkbox_container">
              <span style={{ color: domainBaseColour }} onClick={selectedYes}>
                {domain.Strings.tab1DrawnDownYes}
              </span>
              <span style={{ color: domainBaseColour }} onClick={selectedNo}>
                {domain.Strings.tab1DrawnDownNo}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateInput: ({ name, value }) =>
      dispatch({ type: UPDATE_INPUT, name, value }),
    moveToNextTab: () =>
      dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tab1DrawnDown);
